import { Component, OnInit, OnDestroy } from '@angular/core';
import { LogActivityService } from '../../../../services/settings-services/log-activity.service';
import { GeneralService } from 'src/app/services/general.service';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { Subject } from 'rxjs';
import { LogFeedService } from 'src/app/services/log-activity/logs-feeds.service';
@Component({
  selector: 'app-logactivity-feeds',
  templateUrl: './logactivity-feeds.component.html',
  styleUrls: ['./logactivity-feeds.component.css']
})
export class LogactivityFeedsComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();
  spinnerType: string;
  spinnerStyle: any = {};
  setSpinnerStatus: string;
  showSpinner: boolean = true;
  showSmallSpinner: boolean = false;
  isLoadingMore: boolean = false;
  smallSpinnerStyle: any = { 'margin-left': '' };
  pageContext;
  user;
  supervisor;
  subordinate;
  supervisorUsers;
  activityLogs: Array<any> = [];
  loadedActivityLogs: any = [];
  pageNo: any = 0;


  constructor(
    private logActSrv: LogActivityService,
    private logFeedSrv: LogFeedService,
    private emailService: EmailService,
    private generalTaskSrv: GeneralTaskService,
    private generalSrv: GeneralService,
    store: Store<AppState>
  ) {
    this.spinnerType = "jsBin";
    this.setSpinnerStatus = "";
    this.spinnerStyle = { top: '25%' };
    store.select("userInfo").subscribe(info => {
      this.user = info.user.id;
      this.supervisor = info.supervisor
    });
  }

  ngOnInit() {
    this.pageContext = ''
    this.activityLogs = []
    this.loadedActivityLogs = []
    this.getPageContext();
    //refresh logs
    this.logActSrv.refreshNeeded$
      .subscribe(() => {
        this.pageNo -= 1;
        this.getPageContext();
      })
      if(this.logActSrv.refreshNeeded$){
        console.log('log-refreshed')
      }else {
        console.log('log not refreshed')
      }
  }

  /**
   * Fetch All Activity Logs
   */
  getPageContext() {
    this.isLoadingMore = true;
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
        this.getData(context);
      }
    });
  }

  getData(context) {
    let pageNo = 0;
    pageNo += 1;
    switch (context.name) {

      case 'lead':
        this.logFeedSrv.logFeeds(context.data.id, 4, pageNo)
          .subscribe((activityLogs) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            const logs = [...this.activityLogs, ...activityLogs].sort((a, b) => b.date - a.date);
            this.activityLogs = this.processLogs(logs);
          })
        break;

      case 'dashboard':
        if (this.supervisor) {
          this.generalTaskSrv.getUsersBySupervisor()
            .subscribe(supervisorAttachedUsers => {
              this.supervisorUsers = supervisorAttachedUsers;
              this.subordinate = this.supervisorUsers.map(member => member.id);
              this.logFeedSrv.logFeeds(this.subordinate, 1, pageNo)
                .subscribe((activityLogs) => {
                  // this.showSmallSpinner = !this.showSmallSpinner;
                  const logs = [...this.activityLogs, ...activityLogs].sort((a, b) => b.date - a.date);
                  this.activityLogs = this.processLogs(logs);
                  this.loadedActivityLogs = activityLogs
                })
            })
        } else {
          this.logFeedSrv.logFeeds(context.data.id, 1, pageNo)
            .subscribe((activityLogs) => {
              // this.showSmallSpinner = !this.showSmallSpinner;
              const logs = [...this.activityLogs, ...activityLogs].sort((a, b) => b.date - a.date);
              this.activityLogs = this.processLogs(logs);
            })
        }
        break;

      case 'deal':
        this.logFeedSrv.logFeeds(context.data.id, 3, pageNo)
          .subscribe((activityLogs: any) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            this.activityLogs = activityLogs;
          })
        break;

      case 'company':
        this.logFeedSrv.logFeeds(context.company.clientId, 4, pageNo)
          .subscribe((activityLogs: any) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            this.activityLogs = activityLogs;
          })
        break;

      case 'contact':
        this.logFeedSrv.logFeeds(context.contact.clientId, 4, pageNo)
          .subscribe((activityLogs: any) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            this.activityLogs = activityLogs;
          })
        break;

      case 'salesPerson':
        this.logFeedSrv.logFeeds(context.data.id, 1, pageNo)
          .subscribe((activityLogs: any) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            this.activityLogs = activityLogs;
          })
        break;

      case 'teams':
        this.logFeedSrv.logFeeds(context.data.id, 2, pageNo)
          .subscribe((activityLogs: any) => {
            // this.showSmallSpinner = !this.showSmallSpinner;
            this.activityLogs = activityLogs;
          })
        break;

      default:
        break;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  processLogs(logs) {
    const processedIds = {};
    return logs.reduce((sac, log) => {
      if (processedIds[log.id]) return sac;
      this.isLoadingMore = false;
      processedIds[log.id] = true;
      return [...sac, log];
    }, []);
  }

}
